import { all, call, fork, put, takeEvery,takeLatest,select } from 'redux-saga/effects'
import { action } from 'typesafe-actions'
import { USER} from './UserActions'
import { callApi } from '../../utils/api'
import { GeneralUtil } from '../../utils/generalUtil';
import { authProvider } from '../../utils/authProvider';

const generalUtil:GeneralUtil = new GeneralUtil();

const getUser = async() => {
  let accountInfo = await authProvider.getAccountInfo();
  let id: string = accountInfo === null ? '' : accountInfo?.account.accountIdentifier;

  return await generalUtil.Read(id, 'User');
}

function* verifyUser(account:any) {

  const res = yield call(getUser);
  yield put(action( USER.verify.success ,{ ...res, ...account.payload} ));
   
}

const updateUser = async(user:any) => {
  let accountInfo = await authProvider.getAccountInfo();
  let id: string = accountInfo === null ? '' : accountInfo?.account.accountIdentifier;
  user.id = id;
  user.table = 'User';
  return await generalUtil.Update(user);
}

// function* updateUserProfile(user:any) {
//   const res = yield call(getUser);
//   yield call(updateUser,{ ...res, ...user.payload});
//   yield put(action( USER.Profile.success ,{...res,  ...user.payload} ));
// }
function* updateUserProfile(user:any) {
  //const res = yield call(getUser);
  const res = yield call(updateUser,{ ...user.payload});
  if (res.isSuccess) {
    res.doc.updateState = 1;
    yield put(action( USER.Profile.success , {...res} ));
  } else {
    yield put(action( USER.Profile.error , {"error" : res.errors, "updateState": 2} ));
  }
}

function* handleUserFetchRequest() {
  try {
    const res = yield call(getUser);
    if (res.isSuccess) {
      yield put(action( USER.Profile.success ,{...res.doc} ));
    } else {
      yield put(action( USER.Profile.error , {"error" : res.errors} ));
    }
  } catch (err) {
    if (err instanceof Error && err.stack) {
      yield put(action( USER.Profile.error , err.stack ));
    } else {
      yield put(action( USER.Profile.error , 'An unknown error occured.' ));
    }
  }
}

function* watchUserFetchRequest() {
  yield takeEvery(USER.Profile.request, handleUserFetchRequest)
}

function* watchUserRequest() {
    yield takeLatest(USER.verify.request, verifyUser)
}

function* watchUserUpdate() {
    yield takeLatest(USER.Profile.update, updateUserProfile)
}
  // We can also use `fork()` here to split our saga into multiple watchers.
function* UserSaga() {
    yield all([fork(watchUserRequest),fork(watchUserUpdate),fork(watchUserFetchRequest)])
}
  
  export default UserSaga
  